import { SubscriptionStatus } from "@common/billing";
import { SubscriptionType } from "@common/types/billing";
import { useBillingStatus } from "./useBillingStatus";

export function useBillingType() {
    const { subscriptionDetails } = useBillingStatus();

    if (
        !subscriptionDetails ||
        subscriptionDetails.status !== SubscriptionStatus.ACTIVE
    ) {
        return SubscriptionType.FLAT_RATE;
    }

    return subscriptionDetails.type;
}
